let isYouTubeApiReady = false;
let youtubeApiCallbacks = [];
let apiLoadAttempted = false;
let apiLoadRetries = 0;
const MAX_RETRIES = 3;

/**
 * Loads the YouTube IFrame Player API and executes callback when ready
 * Following official YouTube IFrame API documentation
 * @param {Function} callback - Function to call when API is ready
 */
export const loadYouTubeApi = (callback) => {
  // If YouTube API is already ready, call the callback immediately
  if (window.YT && window.YT.Player && isYouTubeApiReady) {
    console.log('YouTube API already loaded, executing callback');
    setTimeout(() => callback(), 0); // Use setTimeout to avoid potential blocking
    return;
  }

  // Store callback for later execution
  youtubeApiCallbacks.push(callback);

  // If we've already attempted to load the API, don't try again
  if (apiLoadAttempted) {
    console.log('YouTube API load already attempted, waiting for it to complete');
    return;
  }
  
  apiLoadAttempted = true;

  // Create and insert the YouTube iframe API script
  const loadScript = () => {
    try {
      console.log('Loading YouTube IFrame API script');
      const tag = document.createElement('script');
      tag.src = 'https://www.youtube.com/player_api'; // Use player_api as per documentation
      tag.async = true; // Load asynchronously
      
      tag.onload = () => {
        console.log('YouTube IFrame API script loaded successfully');
      };
      
      tag.onerror = (err) => {
        console.error('Error loading YouTube IFrame API:', err);
        // Retry loading if under max retries
        if (apiLoadRetries < MAX_RETRIES) {
          apiLoadRetries++;
          console.log(`Retrying YouTube API load (${apiLoadRetries}/${MAX_RETRIES})`);
          setTimeout(loadScript, 1000);
        } else {
          console.error('Max retries reached for YouTube API loading');
        }
      };
      
      // Insert the script at the beginning of the document
      const firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    } catch (error) {
      console.error('Error setting up YouTube API:', error);
    }
  };

  // Set up the callback for when the API is ready
  window.onYouTubePlayerAPIReady = () => {
    console.log('YouTube Player API ready');
    isYouTubeApiReady = true;
    
    // Execute all callbacks with a small delay to avoid conflicts
    setTimeout(() => {
      console.log(`Executing ${youtubeApiCallbacks.length} YouTube callbacks`);
      youtubeApiCallbacks.forEach(cb => {
        try {
          cb();
        } catch (e) {
          console.error('Error executing YouTube callback:', e);
        }
      });
      youtubeApiCallbacks = [];
    }, 100);
  };
  
  // Start loading the script
  loadScript();
};
